export enum ActionResult {
  SUCCESS_ACTION = 'SUCCESS_ACTION',
  FAIL_ACTION = 'FAIL_ACTION',
}

export interface IActionResultData {
  result: ActionResult;
  data: unknown;
}

export const MAX_FILE_SIZE = 30000000;
